<template>
  <div class="pa-2">
    <div class="d-flex justify-space-between mb-3">
      <v-card-title
        class="px-2 align-self-center secondary--text text-h6 text-md-subtitle-1 font-weight-bold"
      >
        Prix engrais (€/unité)
      </v-card-title>
      <div class="d-flex justify-space-around">
        <AgrButton
          outlined
          @click="isAjoutParametreOpen = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Ajouter un prix
        </AgrButton>
      </div>
    </div>
    <BaseLoader v-if="loading" />
    <div
      v-else
      class="d-flex flex-row justify-space-around flex-wrap"
    >
      <div
        v-for="unite in unitesEngraisSorted"
        :key="unite.id"
        class="d-flex justify-space-between mb-2"
      >
        <div
          class="align-self-center intro texte-gris-fonce mr-5"
        >
          <span v-if="unite.libelle === 'CaO'"> Coût kg Cao</span>
          <span v-else>Coût unité {{ unite.libelle }}</span>
        </div>
        <div class="align-self-center intro secondary--text">
          {{ unite.prixEnEuroUnite ? unite.prixEnEuroUnite : '-' }}
        </div>
        
        <AgrButton
          icon
          @click="openUpdateModale(unite)"
        >
          <v-icon color="grey darken-2">
            mdi-pencil-outline
          </v-icon>
        </AgrButton>
        <AgrButton
          v-if="unite.statut !== 'OBLIGATOIRE'"
          icon
          @click="openDeleteModale(unite)"
        >
          <v-icon color="grey darken-2">
            mdi-delete-outline
          </v-icon>
        </AgrButton>
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalUpdatePrixEngrais"
      fullscreen
      persistent
      transition="slide-x-transition"
    >
      <UpdatePrixModal
        v-if="isOpenModalUpdatePrixEngrais"
        :unite-engrais="uniteEngraisSelected"
        @close="isOpenModalUpdatePrixEngrais = false"
        @save="updatePrix"
      />
    </v-dialog>
    <v-dialog
      v-if="isAjoutParametreOpen"
      v-model="isAjoutParametreOpen"
      persistent
      false
      width="500"
    >
      <NewParametrePrixModal
        @close="isAjoutParametreOpen = false"
        @save="addPrix"
      />
    </v-dialog>
    <v-dialog
      v-model="isConfirmDeleteParametreModalOpen"
      persistent
      width="500"
    >
      <ConfirmModal
        title="Confirmation"
        cancel-text="Non"
        confirm-text="Oui"
        @cancel="isConfirmDeleteParametreModalOpen=false"
        @confirm="confirmDeleteParametre()"
      >
        Souhaitez-vous vraiment supprimer ce paramètre ?
      </ConfirmModal>
    </v-dialog>
    <v-snackbar
      v-if="error"
      v-model="error"
      class="top-snackbar"
      top
      right
      timeout="5000"
      color="red"
    >
      <v-icon
        color="white"
        class="mr-3"
      >
        mdi-alert-circle
      </v-icon>
      <span class="action white--text"> {{ error }} </span>
    </v-snackbar>
  </div>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import UpdatePrixModal from './modal/update-prix-modal.vue'
import NewParametrePrixModal from './modal/new-parametre-prix-modal.vue'
import { mapActions, mapGetters } from 'vuex'
import { sortBy } from 'lodash'

export default {
  name: 'CartePrix',
  components: { AgrButton, BaseLoader, ConfirmModal, NewParametrePrixModal, UpdatePrixModal },
  data () {
    return {
      isOpenModalUpdatePrixEngrais: false,
      isAjoutParametreOpen: false,
      isConfirmDeleteParametreModalOpen: false,
      loading: false,
      error: null,
      uniteEngraisSelected: null
    }
  },
  computed: {
    ...mapGetters({
      unitesEngrais: 'comparateurMarge/unitesEngrais'
    }),
    unitesEngraisSorted () {
      return sortBy(this.unitesEngrais, 'id')
    }
  },

  created () {
    this.loading = true
    this.getAdminComparateurMargeUniteEngrais()
      .finally(() => {
        this.loading = false
    })
  },

  methods: {
    ...mapActions({
      getAdminComparateurMargeUniteEngrais: 'comparateurMarge/getAdminComparateurMargeUniteEngrais',
      createOrUpdateAdminComparateurMargeUnitesEngrais: 'comparateurMarge/createOrUpdateAdminComparateurMargeUnitesEngrais',
      deleteAdminComparateurMargeUnitesEngrais: 'comparateurMarge/deleteAdminComparateurMargeUnitesEngrais'
    }),
    openUpdateModale (uniteEngrais) {
      this.isOpenModalUpdatePrixEngrais = true
      this.uniteEngraisSelected = uniteEngrais
    },
    openDeleteModale (uniteEngrais) {
      this.error = null
      this.isConfirmDeleteParametreModalOpen = true
      this.uniteEngraisSelected = uniteEngrais
    },
    confirmDeleteParametre () {
      this.deleteAdminComparateurMargeUnitesEngrais(this.uniteEngraisSelected.id)
        .then(() => {
          this.$emit('updatePrix')
          this.isConfirmDeleteParametreModalOpen = false
        })
        .catch((error) => {
          this.error = error.response.data.message
          this.isConfirmDeleteParametreModalOpen = false
        })
    },
    updatePrix () {
      this.isOpenModalUpdatePrixEngrais = false
      this.$emit('updatePrix')
    },
    addPrix () {
      this.isAjoutParametreOpen = false
      this.$emit('updatePrix')
    }
  }
}
</script>
<style lang="scss" scoped>
.top-snackbar {
  top: 130px !important;
}
</style>
